import { useMemo } from "react";

export type DataPackageOption = {
  id: number;
  name: string;
  arenaId: number | null;
  isSystem: boolean;
  currentVersionId: number | null;
};

/**
 * Groups `dataPackageOptions` into labelled sections (system vs arena).
 *
 * The caller is responsible for passing only compatible packages (e.g. already
 * filtered by templateType on the backend).
 */
export const useDataPackageSections = (
  dataPackageOptions: DataPackageOption[],
  arenaName: string,
) =>
  useMemo(() => {
    const { system, arena } = dataPackageOptions.reduce<{
      system: DataPackageOption[];
      arena: DataPackageOption[];
    }>(
      (acc, pkg) => {
        (pkg.isSystem ? acc.system : acc.arena).push(pkg);
        return acc;
      },
      { system: [], arena: [] },
    );
    const sections: { name: string; packages: DataPackageOption[] }[] = [];
    if (system.length > 0) sections.push({ name: "GL Data System", packages: system });
    if (arena.length > 0) sections.push({ name: `GL Data ${arenaName}`, packages: arena });
    return sections;
  }, [dataPackageOptions, arenaName]);
